import Link from '@decisiv/ui-components/lib/components/Link';

import HighlightText from 'components/HighlightedText';
import { useSearchContext } from 'contexts/SearchContext';
import TeamsPageNameCell from 'pages/Teams/Cells/NameCell';
import {
  hasNoPlatformAccounts,
  noPlatformAccountsReason,
} from 'pages/Teams/Cells/NameCell/noPlatformAccounts';
import ROUTE_NAMES from 'setup/Routing/routeNames';
import useFeatureFlag, { FEATURE_FLAGS } from 'utils/useFeatureFlag';
import type { ManagedTeamsType } from '../..';

interface CellProps {
  rowData: ManagedTeamsType;
}

export default function TeamNameCell({ rowData }: CellProps) {
  const fleetAssetManagementEnabled = useFeatureFlag(
    FEATURE_FLAGS.PD_5874_FLEET_ASSET_MANAGEMENT,
  );
  const { searchString } = useSearchContext();
  const hasNoAccounts = hasNoPlatformAccounts(rowData.platformAccounts);

  // PD-5874: the name opens the in-app Team page, which works for a team
  // with no accounts too. Opening PSSM Fleet moved to the row actions menu
  // (TeamActionsCell).
  if (fleetAssetManagementEnabled) {
    return (
      <Link
        to={ROUTE_NAMES.forAdminManagementTeam(rowData.id)}
        text={<HighlightText text={rowData.name} searchText={searchString} />}
      />
    );
  }

  return (
    <TeamsPageNameCell
      hideLogo
      rowData={rowData}
      openInNewTab
      disabled={hasNoAccounts}
      disabledReason={hasNoAccounts ? noPlatformAccountsReason() : undefined}
    />
  );
}
